import { render, staticRenderFns } from "./bom.vue?vue&type=template&id=b64d1600&scoped=true"
import script from "./bom.vue?vue&type=script&lang=js"
export * from "./bom.vue?vue&type=script&lang=js"
import style0 from "./bom.vue?vue&type=style&index=0&id=b64d1600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64d1600",
  null
  
)

export default component.exports